import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    border: "none",
    minHeight: "100%"
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 20,
    minHeight: 68,
    color: theme.palette.text.primary,
    borderTop: "1px solid #eeeeee",
    "&:nth-child(2n)": {
      backgroundColor: "rgba(238, 238, 238, 0.25)"
    },
    "&:first-child": {
      backgroundColor: theme.palette.common.white,
      borderTop: "none"
    },
    "&:last-child": {
      backgroundColor: theme.palette.common.white,
      borderBottom: "1px solid transparent"
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 47,
      paddingTop: 6,
      paddingBottom: 6
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 42,
      paddingTop: 10,
      paddingBottom: 10
    }
  },
  label: {
    fontSize: 14,
    whiteSpace: "nowrap",
    marginRight: 8
  },
  value: {
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  horseName: {
    fontSize: 18
  },
  horseId: {
    fontSize: 16
  },
  snacks: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    paddingLeft: 16
  },
  grow: {
    flexGrow: 1
  },
  action: {
    justifyContent: "center",
    backgroundColor: theme.palette.common.white
  },
  moreInfoLink: {
    textDecoration: "none",
    "& .MuiTypography-root": {
      color: theme.palette.secondary.dark
    }
  },
  moreInfoLinkText: {
    fontSize: 13,
    cursor: "pointer"
  },
  none: {
    color: theme.palette.text.hint,
    fontSize: 14
  }
}));
